import { styled, Table, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';


const prefix = "RaDatagrid"
const classes = {
    table: `${prefix}-table`,
    thead: `${prefix}-thead`,
    tbody: `${prefix}-tbody`,
    headerRow: `${prefix}-headerRow`,
    headerCell: `${prefix}-headerCell`,
    checkbox: `${prefix}-checkbox`,
    row: `${prefix}-row`,
    clickableRow: `${prefix}-clickableRow`,
    rowEven: `${prefix}-rowEven`,
    rowOdd: `${prefix}-rowOdd`,
    rowCell: `${prefix}-rowCell`,
    expandHeader: `${prefix}-expandHeader`,
    expandIconCell: `${prefix}-expandIconCell`,
    expendIconCellExpended: `${prefix}-expendIconCellExpended`,
    expandIcon: `${prefix}-expandIcon`,
    expanded: `${prefix}-expanded`,
    expandedPanel: `${prefix}-expandedPanel`,
}

export const datagridClasses = classes;

export const DatagridRoot = styled(Table)(({theme}) => ({
    [`&.${classes.table}`]: {
        tableLayout: 'auto',
    },
    [`& .${classes.thead}`]: {},
    [`& .${classes.tbody}`]: {},
    [`& .${classes.headerRow}`]: {},
    [`& .${classes.headerCell}`]: {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: theme.palette.background.paper,
        '&:first-of-type': {
            borderTopLeftRadius: theme.shape.borderRadius,
        },
        '&:last-of-type': {
            borderTopRightRadius: theme.shape.borderRadius,
        },
    },
    [`& .${classes.checkbox}`]: {},
    [`& .${classes.row}`]: {},
    [`& .${classes.clickableRow}`]: {
        cursor: 'pointer',
    },
    [`& .${classes.rowEven}`]: {},
    [`& .${classes.rowOdd}`]: {},
    [`& .${classes.rowCell}`]: {},
    [`& .${classes.expandHeader}`]: {
        padding: 0,
        width: theme.spacing(6),
    },
    [`& .${classes.expandIconCell}`]: {
        paddingLeft: theme.spacing(1),
        width: theme.spacing(6),
    },
    [`& .${classes.expendIconCellExpended}`]: {
        position: 'relative',
        '&:after': {
            position: 'absolute',
            content: '" "',
            top: 0,
            left: 0,
            backgroundColor: theme.palette.primary.main,
            width: 3,
            height: 'calc(100% + 1px)'
        }
    },
    [`& .${classes.expandIcon}`]: {
        padding: theme.spacing(1),
        transform: 'rotate(-90deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    [`& .${classes.expanded}`]: {
        transform: 'rotate(0deg)',
        color: theme.palette.text.secondary,
    },
    [`& .${classes.expandedPanel}`]: {
        position: 'relative',
        '& td:after': {
            position: 'absolute',
            content: '" "',
            top: 0,
            left: 0,
            backgroundColor: theme.palette.primary.main,
            width: 3,
            height: 'calc(100% + 1px)'
        }
    },
}))
